import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const BREAKPOINT_LABELS = ['Score 5 at', 'Score 4 at', 'Score 3 at', 'Score 2 at'];

const defaultDirectionNote = (indicator) =>
  indicator.direction === 'lower' ? ' (lower is better)' : '';

const BreakpointEditor = ({
  indicators,
  breakpointsById,
  onChange,
  onReset,
  directionNote = defaultDirectionNote,
  description = "Values at or beyond the Score 5 cutoff get a 5; below Score 2 they use the indicator's floor rule.",
}) => (
  <Accordion
    elevation={0}
    disableGutters
    sx={{ bgcolor: 'transparent', '&:before': { display: 'none' } }}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 2 }}>
      <Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Advanced: score breakpoints
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {description}
        </Typography>
      </Box>
    </AccordionSummary>
    <AccordionDetails>
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1.5 }}>
        <Button size="small" onClick={onReset}>
          Reset breakpoints
        </Button>
      </Stack>
      {indicators.map((indicator) => {
        const values = breakpointsById[indicator.id] || indicator.breakpoints;
        return (
          <Box
            key={indicator.id}
            sx={{
              mb: 2,
              pb: 2,
              borderBottom: '1px solid',
              borderColor: 'divider',
              '&:last-of-type': { borderBottom: 'none', mb: 0, pb: 0 },
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
              {indicator.label}
              {directionNote(indicator)}
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
              {values.map((value, index) => (
                <TextField
                  key={BREAKPOINT_LABELS[index]}
                  size="small"
                  type="number"
                  label={BREAKPOINT_LABELS[index]}
                  value={value}
                  onChange={(event) => {
                    const next = [...values];
                    next[index] = event.target.value === '' ? '' : Number(event.target.value);
                    onChange(indicator.id, next);
                  }}
                  inputProps={{ step: 'any' }}
                />
              ))}
            </Stack>
          </Box>
        );
      })}
    </AccordionDetails>
  </Accordion>
);

export default BreakpointEditor;
